exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.projectDetailsText[data-v-335860ea]{padding-right:6px !important;font-size:1.1rem !important;color:gray !important;text-align:left !important\n}", ""]);

// exports
